import { MailToField } from 'craft/containers/Actions/fields/MailToField';
import { TriggerClickField } from 'craft/containers/Actions/fields/TriggerClickField';
import { ContentCollection, INTERACTION_TYPES } from 'craft/types';

import { CallbackField } from './CallbackField';
import { ChangeContentField } from './ChangeContentField';
import { FlowField } from './FlowField';
import { GuideField } from './GuideField';
import { NavigateField } from './NavigateField';
import { TourField } from './TourField';
import {
  TriggerHotspotGroupField,
  TriggerModalField,
  TriggerTourField,
} from './TriggerContentField';

export interface InteractionFieldProps<T> {
  defaultValue?: Partial<T>;
  collection?: ContentCollection | null;
  onChange: (handler?: Partial<T>) => any;
  nodeIds: string[];
}

export type InteractionField =
  | (<T>(props: InteractionFieldProps<T>) => JSX.Element | null)
  | undefined;

// @ts-ignore
export const interactionFields: Partial<Record<INTERACTION_TYPES, InteractionField>> = {
  [INTERACTION_TYPES.URL]: NavigateField,
  [INTERACTION_TYPES.Email]: MailToField,
  [INTERACTION_TYPES.Callback]: CallbackField,
  [INTERACTION_TYPES.Content]: ChangeContentField,
  [INTERACTION_TYPES.TriggerModal]: TriggerModalField,
  [INTERACTION_TYPES.TriggerTour]: TriggerTourField,
  [INTERACTION_TYPES.TriggerHotspotGroup]: TriggerHotspotGroupField,
  [INTERACTION_TYPES.Guide]: GuideField,
  [INTERACTION_TYPES.Flow]: FlowField,
  [INTERACTION_TYPES.Tour]: TourField,
  [INTERACTION_TYPES.TriggerClick]: TriggerClickField,
};
